






































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import '@/compiled-icons/device-xs';
import '@/compiled-icons/device-sm';
import '@/compiled-icons/device-md';
import '@/compiled-icons/device-lg';
import '@/compiled-icons/device-xl';
import {DynamicDocumentUtils} from '@/views/dynamicdocuments/dynamic-document.utils';

import '@/compiled-icons/add';

@Component({
  name: 'dynamic-document-screen-width-configuration-template',
  components: {
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentScreenWidthConfigurationTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;

  sizes = DynamicDocumentUtils.SIZE_SELECTOR;

}
